import DateField from './components/inputs/DateField.vue';
import FilterableSelect from './components/inputs/FilterableSelect.vue';

// Зарегистрировать глобально кастомные компоненты
export default function registerCustomComponents(vue) {
  vue.component('DateField', DateField);
  vue.component('FilterableSelect', FilterableSelect);
}
